import { render, staticRenderFns } from "./EditScene.vue?vue&type=template&id=3e929891&"
import script from "./EditScene.vue?vue&type=script&lang=js&"
export * from "./EditScene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports